import { useFormik } from "formik";
import { useState } from "react";
import * as Yup from "yup";

export const FormState = {
  Init: "init",
  Sending: "sending",
  Success: "success",
  Error: "error",
};

export const useContactForm = () => {
  const [state, setState] = useState(FormState.Init);

  const {
    values,
    errors,
    touched,
    isSubmitting,
    setSubmitting,
    handleSubmit,
    handleChange,
    handleBlur,
  } = useFormik({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      message: "",
    },

    validationSchema: Yup.object({
      name: Yup.string().required("El campo Nombre y apellido es requerido"),
      email: Yup.string()
        .email("No es un correo electrónico válido")
        .required("El campo Correo electrónico es requerido"),
      message: Yup.string().required("El campo Mensaje es requerido"),
    }),

    onSubmit: (formData, actions) => {
      setState(FormState.Sending);
      fetch("https://formsubmit.co/ajax/verdivia.mza@gmail.com", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          Nombre: formData.name,
          eMail: formData.email,
          Teléfono: formData.phone,
          Mensaje: formData.message,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          setState(FormState.Success);
          actions.resetForm();
        })
        .catch((error) => {
          setTimeout(() => {
            setState(FormState.Error);
          }, 2500);
          setTimeout(() => {
            setSubmitting(false);
            setState(FormState.Init);
          }, 6000);
        });
    },
  });

  return {
    values,
    errors,
    touched,
    isSubmitting,
    handleSubmit,
    handleChange,
    handleBlur,
    state,
  };
};
